export default __webpack_public_path__ + "static/piscina-e08469ce4491797dae6cdf9cb84004bf.jpg";